export { CatchAllClassificationStrategy } from './strategy';
export type { CatchAllClassificationRule } from './rule';
